export const CONTENT_SEARCH_MAX_HEIGHT = 195 as const;
export const CONTENT_SEARCH_DEFAULT_LIMIT = 10 as const;
export const CONTENT_SEARCH_DEFAULT_PAGE_SIZE = 40 as const;
export const CONTENT_SEARCH_WARNING_ID = 'content-search-warning';
